module.exports = __webpack_public_path__ + "img/mythical-screenshot.dcbb5462.png";